import React from "react";
import { Segment, Header } from "semantic-ui-react";

class MasterColegiosLista extends React.Component {
  render() {
    return (
      <Segment>
        <Header as="h3" content="Master Colegios Lista" />
      </Segment>
    );
  }
}

export default MasterColegiosLista;



// WEBPACK FOOTER //
// ./src/pages/colegios/MasterColegiosLista.jsx